import { render } from "./ModalPaymentHistoryDetail.vue?vue&type=template&id=b62dee64&scoped=true"
import script from "./ModalPaymentHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ModalPaymentHistoryDetail.vue?vue&type=script&lang=js"

import "./ModalPaymentHistoryDetail.vue?vue&type=style&index=0&id=b62dee64&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b62dee64"]])

export default __exports__